import orderBy from 'lodash.orderby';
import values from 'lodash.values';
import moment from 'moment';

export const getMessages = state => {
  const messages = values(state.data);
  return orderBy(messages, ['date'], ['asc']);
};

export const getMessagesAfterDate = (state, date) => {
  const messages = values(state.data);
  return messages.filter(msg => moment(msg.date).isAfter(moment(date)));
};

export const getPaymentAssets = state => state.paymentAssets;
export const getPendingAttachments = state => state.attachments;
export const getPendingMessages = state => state.pending;
export const getMessageById = (state, id) => state.data[id] || null;

export default {
  getPaymentAssets,
  getMessages,
  getMessagesAfterDate,
  getPendingAttachments,
  getPendingMessages,
  getMessageById,
};
